import { useState } from 'react';
// @mui
import { Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import HubspotContactForm from '../forms/HubspotContactForm';
import { contactFormConfig } from '../forms/hubspot-config';
// hooks
import useSubscriptions from 'src/hooks/useSubscriptions';
// styles
import { StyledFooterTile } from './styles';
import { LoadingButton } from "@mui/lab";
import { CubesIcon } from 'src/theme/overrides/CustomIcons';

// ----------------------------------------------------------------------

const FooterTile = () => {
  const [isOpenContactModal, setIsOpenContactModal] = useState(false);

  const {
    daysLeft,
    showStartTrialMessage,
    trialExpiresMessage,
    activateYourPlansMessage,
    startTrial,
    subscriptionsAreLoading
  } = useSubscriptions();

  const upgradePlanButton = (
    <Button
      variant='text'
      color="carbon"
      component={RouterLink}
      to={PATH_DASHBOARD.user.plans}
      endIcon={<CubesIcon size='small' />}
    >
      Upgrade today
    </Button>
  )

  const componentId = 'subscription-status-footer-bar';

  if (!subscriptionsAreLoading && trialExpiresMessage) {
    return (
      <StyledFooterTile id={componentId}>
        <Typography variant="h6">You have {daysLeft} days left in</Typography>
        <Typography variant="h6" gutterBottom>your trial.</Typography>
        <Typography >Don't miss out - upgrade</Typography>
        <Typography>your plan now to keep</Typography>
        <Typography>enjoying our premium</Typography>
        <Typography gutterBottom>features.</Typography>

        {upgradePlanButton}
      </StyledFooterTile>
    )
  } else if (!subscriptionsAreLoading && showStartTrialMessage) {
    return (
      <StyledFooterTile id={componentId}>
        <Typography variant="h6" >You are currently on a</Typography>
        <Typography variant="h6" gutterBottom>free account.</Typography>
        <Typography>To explore CarbonClick’s</Typography>
        <Typography>premium features start</Typography>
        <Typography gutterBottom>your free trial today.</Typography>

        <LoadingButton
          loading={subscriptionsAreLoading}
          onClick={startTrial}
          variant='text'
          color="carbon"
          endIcon={<CubesIcon size='small' />}
        >
          Start free trial
        </LoadingButton>
      </StyledFooterTile>
    );
  } else if (!subscriptionsAreLoading && activateYourPlansMessage) {
    return (
      <StyledFooterTile id={componentId}>
        <Typography variant="h6" >You are currently on a</Typography>
        <Typography variant="h6" gutterBottom>free account.</Typography>
        <Typography>To access CarbonClick’s</Typography>
        <Typography>premium features please</Typography>
        <Typography gutterBottom>upgrade your plan.</Typography>

        {upgradePlanButton}
      </StyledFooterTile>
    )
  } else if (!subscriptionsAreLoading) {
    return (
      <StyledFooterTile id={componentId}>
        <Typography variant='body2'>Learn how we can design your</Typography>
        <Typography variant='body2'>climate program to resonate</Typography>
        <Typography variant='body2' gutterBottom>with your markets.</Typography>

        <Button
          onClick={() => setIsOpenContactModal(true)}
          variant='text'
          color="carbon"
          endIcon={<CubesIcon size='small' />}
          size='small'
        >
          Contact us
        </Button>

        {isOpenContactModal&& (
          <HubspotContactForm
            isModalOpen={isOpenContactModal}
            setIsModalOpen={setIsOpenContactModal}
            region={contactFormConfig.region}
            portalId={contactFormConfig.portalId}
            formId={contactFormConfig.formId}
          />
        )}
      </StyledFooterTile>
    );
  } else {
    return null;
  }
};

export default FooterTile;
